import React from 'react';
import { navigationIconRegistry as navRegistry } from '../../types/iconRegistry';
import { navigation } from '../../mocks/dashboard';

function Sidebar({ activePage, onNavigate, open, onClose }) {
  const CloseIcon = navRegistry.x;
  const SettingsIcon = navRegistry.settings;
  const MoreIcon = navRegistry.moreHorizontal;

  return (
    <aside className={`sidebar ${open ? 'sidebar-open' : ''}`}>
      <div className="brand">
        <div className="brand-mark"><span /></div>
        <div><strong>AGI</strong><small>AGENCY OPS</small></div>
        <button className="mobile-close" onClick={onClose} type="button">
          <CloseIcon />
        </button>
      </div>

      <nav>
        <p className="nav-label">MISSION CONTROL</p>
        {navigation.map((item) => {
          const NavigationIcon = navRegistry[item.icon] || navRegistry.grid;

          return (
            <button
              className={activePage === item.id ? 'nav-item active' : 'nav-item'}
              key={item.id}
              onClick={() => {
                onNavigate(item.id);
                onClose();
              }}
              type="button"
            >
              <NavigationIcon />
              <span>{item.label}</span>
              {item.count && <b>{item.count}</b>}
            </button>
          );
        })}
      </nav>

      <div className="sidebar-bottom">
        <button className="nav-item" type="button">
          <SettingsIcon />
          <span>Settings</span>
        </button>
        <div className="operator">
          <div className="operator-avatar">SC</div>
          <div><strong>Sarah Chen</strong><span><i /> Agency admin</span></div>
          <MoreIcon />
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;